import React from 'react';
import { Minus, Plus } from 'lucide-react';

// Réglage d'AFFICHAGE (nombre de colonnes) — stepper −/+ épuré, séparé des filtres.
// « Auto » = densité responsive par défaut (4 col en 2K, 5 en 4K…). −/+ basculent en
// manuel et laissent monter jusqu'à 8 colonnes (utile sur très grand écran) ou descendre
// à 1 (cartes géantes, accessibilité). Cliquer la valeur centrale revient à « Auto ».
// Valeur portée par le parent (localStorage). Refonte filtres 2026-06-01.

const MIN = 1;
const MAX = 8;

// Mirroir du ladder responsive (GRID_CLASSES.auto) pour amorcer le manuel depuis l'« Auto ».
function responsiveCols(w) {
  if (w >= 3840) return 7;
  if (w >= 3200) return 6;
  if (w >= 2560) return 5;
  if (w >= 1536) return 4;
  if (w >= 1280) return 3;
  if (w >= 640) return 2;
  return 1;
}

export default function DensityControl({ value, onChange }) {
  const isAuto = value === 'auto';
  const current = isAuto
    ? (typeof window !== 'undefined' ? responsiveCols(window.innerWidth) : 4)
    : parseInt(value, 10);

  const step = (delta) => onChange(String(Math.max(MIN, Math.min(MAX, current + delta))));

  const btn = 'flex items-center justify-center w-8 h-8 text-slate-500 disabled:text-slate-200 disabled:cursor-not-allowed hover:text-secondary hover:bg-secondary/5 transition-colors';

  return (
    <div
      className="inline-flex items-center rounded-sm border border-slate-200 bg-white overflow-hidden"
      role="group"
      aria-label="Nombre de colonnes"
      data-testid="density-control"
    >
      <span className="hidden sm:inline font-accent text-[10px] uppercase tracking-widest text-slate-400 px-2.5">Colonnes</span>
      <button type="button" onClick={() => step(-1)} disabled={current <= MIN} aria-label="Moins de colonnes" title="Moins de colonnes" data-testid="density-dec" className={`${btn} border-l border-slate-200`}>
        <Minus className="w-3.5 h-3.5" />
      </button>
      <button
        type="button"
        onClick={() => onChange('auto')}
        title={isAuto ? 'Densité automatique (selon l’écran)' : 'Revenir à la densité automatique'}
        aria-label={isAuto ? 'Densité automatique' : `${current} colonnes — cliquer pour automatique`}
        data-testid="density-value"
        className={`min-w-[3rem] h-8 px-1 text-xs font-semibold uppercase tracking-wider tabular-nums transition-colors ${
          isAuto ? 'text-slate-500 hover:text-secondary' : 'bg-secondary/10 text-secondary'
        }`}
      >
        {isAuto ? 'Auto' : current}
      </button>
      <button type="button" onClick={() => step(1)} disabled={current >= MAX} aria-label="Plus de colonnes" title="Plus de colonnes" data-testid="density-inc" className={`${btn} border-l border-slate-200`}>
        <Plus className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
